<!--  -->
<template>
  <div class="login">
    <div class="tabsBox">
      <h3 style="font-weight: 600;font-size: 36px;color: rgba(51,51,51,0.9);">欢迎使用开翻</h3>
      <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top:46px;">
        <el-tab-pane label="验证码登录" name="a">
          <el-form
            :model="ruleForm1"
            :rules="rules"
            ref="ruleForm1"
            class="demo-ruleForm"
          >
            <el-form-item prop="name">
              <el-input
                v-model="ruleForm1.name"
                placeholder="手机号/邮箱"
                maxlength="50"
                prefix-icon="el-icon-user"
              ></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <div class="justify">
                <el-input
                  v-model.trim="ruleForm1.code"
                  placeholder="请输入验证码"
                  class="phoneCodeV"
                  maxlength="6"
                  prefix-icon="el-icon-lock"
                ></el-input>
                <el-button
                  class="phoneCode"
                  type="text"
                  :disabled="coolDown"
                  @click="goVerify"
                  >{{
                    coolDown ? `${totalTime}s` : "获取验证码"
                  }}</el-button
                >
              </div>
            </el-form-item>
          </el-form>
          <div class="flex" style="margin-bottom:46px;">
        <el-tooltip class="item" effect="light" placement="left" popper-class="loginHide">
          <div slot="content">
            开翻平台已升级，不再支持“账号登录”，
            <br />请通过您得账号 绑定的手机 邮箱进行登录。
            <br />如有更多登录问题，请描述问题致信<br />weizheng.guan@ctis-cn.com
          </div>
          <p
            style="
              color: #333;
              font-size: 14px;
              width: 90px;
            "
          >
            无法登录
            <i class="el-icon-question" style="font-size: 14px;background: transparent;"></i>
          </p>
        </el-tooltip>
        <el-button type="text" @click="goForget" style="padding:0px;">忘记密码</el-button>
      </div>
      <el-button
        @click="submitLogin()"
        style="width: 100%;font-weight: bold;"
        type="primary"
        >立即登录</el-button
      >
            <el-checkbox
        v-model="checked"
        style="
          font-weight: 400;
          font-size: 12px;
          color: #666666;
          width: 390px;
          word-wrap: break-word;
          word-break: normal;
        "
        >未注册过开翻的手机号，我们将自动帮你注册账号，登录或完成注册 </br> 即代表你同意
        <el-button type="text" @click="toServe()" style="color:#597DFC; font-size: 12px;">《服务协议》</el-button>
        <span>和</span>
        <el-button type="text" @click="toPrivacy()" style="color:#597DFC; font-size: 12px;">《隐私政策》</el-button>
      </el-checkbox>
        </el-tab-pane>
        <el-tab-pane label="密码登录" name="b">
          <el-form
            :model="ruleForm2"
            :rules="rules"
            ref="ruleForm2"
            class="demo-ruleForm"
          >
            <el-form-item prop="name">
              <el-input
                v-model="ruleForm2.name"
                placeholder="手机号/邮箱"
                maxlength="50"
                prefix-icon="el-icon-user"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <div class="justify">
                <el-input
                  v-model="ruleForm2.password"
                  placeholder="请输入密码"
                  prefix-icon="el-icon-lock"
                  :type=passType
                >
                <i slot="suffix"  :class="passFlag?'open':'close'" @click="passHandle"></i>
              </el-input>
              </div>
            </el-form-item>
            <!-- <el-button
              @click="submitPassword('ruleForm2')"
              style="width: 100%"
              type="primary"
              >立即登录</el-button
            > -->
            <!-- <slide-verify
              v-show="flagP"
              ref="slideblockP"
              @again="onAgain"
              @fulfilled="onFulfilled"
              @success="onSuccessP"
              @fail="onFail"
              @refresh="onRefresh"
              :accuracy="6"
              :imgs="imgs"
              slider-text="拖动滑块完成拼图"
              :l="canvas.l"
              :r="canvas.r"
              :w="canvas.w"
              :h="canvas.h"
            ></slide-verify>-->
          </el-form>
          <div class="flex" style="margin-bottom:46px;">
        <el-tooltip class="item" effect="light" placement="left" popper-class="loginHide">
          <div slot="content">
            开翻平台已升级，不再支持“账号登录”，
            <br />请通过您得账号 绑定的手机 邮箱进行登录。
          </div>
          <p
            style="
              color: #333;
              font-size: 14px;
              width: 90px;
            "
          >
            无法登录
            <i class="el-icon-question" style="font-size: 14px;background: transparent;"></i>
          </p>
        </el-tooltip>
        <el-button type="text" @click="goForget" style="padding:0px;">忘记密码</el-button>
      </div>
      <el-button
              @click="submitPassword('ruleForm2')"
              style="width: 100%;font-weight: bold;"
              type="primary"
              >立即登录</el-button
            >
            <el-checkbox
        v-model="checked"
        style="
          font-weight: 400;
          font-size: 12px;
          color: #666666;
          width: 390px;
          word-wrap: break-word;
          word-break: normal;
        "
        >未注册过开翻的手机号，我们将自动帮你注册账号，登录或完成注册 </br> 即代表你同意
        <el-button type="text" @click="toServe()" style="color:#597DFC;font-size: 12px;">《服务协议》</el-button>
        <span>和</span>
        <el-button type="text" @click="toPrivacy()" style="color:#597DFC;font-size: 12px;">《隐私政策》</el-button>
      </el-checkbox>
        </el-tab-pane>
      </el-tabs>
    </div>
    
    <div class="mask" v-show="flag">
      <div class="box">
        <div class="flex title">
          <p>请完成安全验证</p>
          <i class="el-icon-close" @click="flag = false"></i>
        </div>
        <slide-verify
          ref="slideblock"
          @again="onAgain"
          @fulfilled="onFulfilled"
          @success="onSuccess"
          @fail="onFail"
          @refresh="onRefresh"
          :accuracy="6"
          :imgs="imgs"
          slider-text="拖动滑块完成拼图"
          :l="canvas.l"
          :r="canvas.r"
          :w="canvas.w"
          :h="canvas.h"
        ></slide-verify>
      </div>
    </div>
  </div>
    <!--
      success	返回时间参数，单位为毫秒
      fail	验证不通过时的回调函数
      refresh	点击刷新按钮后的回调函数
      again	检测到非人为操作滑动时触发的回调函数
      fulfilled	刷新成功之后的回调函数
    -->
</template>

<script>
import { API_1, Public } from "@/conf/api";
import md5 from "js-md5";
export default {
  components: {},
  data() {
    //这里存放数据
    return {
      passFlag: false,
      passType: "password",
      checked: false, //是否勾选协议
      dialogVisible: true,
      forget: false,
      coolDown: false,
      totalTime: 60,
      timer: null, //验证码倒计时
      ruleForm1: {
        name: "",
        code: "",
      },
      ruleForm2: {
        name: "",
        password: "",
      },
      ruleForm3: {
        name: "",
        password: "",
        passwordAgain: "",
        code: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入手机号或邮箱", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      activeName: "a",
      flag: false, //验证码机器人验证显示隐藏控制
      // flagP: false, //密码登录机器人验证显示隐藏控制
      // flagF: false, //忘记密码机器人验证
      canvas: {
        l: 28, //滑动碎片的大小
        r: 7, //滑动碎片的圆角
        w: 400, //画布的宽
        h: 250, //画布的高
      },
      imgs: [
        require("@/assets/login/slide1.png"),
        require("@/assets/login/slide2.png"),
        require("@/assets/login/slide3.png"),
        require("@/assets/login/slide4.png"),
      ], //自定义的随机图片
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    passHandle() {
      this.passFlag = !this.passFlag;
      if (this.passFlag) {
        this.passType = "text";
      } else {
        this.passType = "password";
      }
    },
    toServe() {
      this.$router.push("/serviceAgreement");
    },
    toPrivacy() {
      this.$router.push("/legalPrivacy");
    },
    goForget() {
      this.$router.push("/forget");
    },
    submitPassword(formName) {
      if (this.checked) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$refs.slideblock.reset();
            this.flag = true;
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } else {
        this.$message({
          message: "请阅读并同意《服务协议》和《隐私政策》后进行登录",
          type: "warning",
          offset: 100,
          customClass: "loginPop",
        });
      }
    },
    passwordLogin() {
      //密码登录 先走防机器验证 然后去登录
      let params = this.$qs.stringify({
        terminal: this.ruleForm2.name,
        password: md5(this.ruleForm2.password),
      });
      this.$axios
        .post(API_1 + Public.passwordLogin, params)
        .then((res) => {
          let status = res.data.status;
          if (status) {
            this.$cookie.set("token", res.data.data.Token, "90d");
            this.$cookie.set("uid", res.data.data.id, "90d");
            this.$message({
              message: "登录成功，欢迎来到开翻",
              type: "success",
            });
            const redirectPath = this.$route.query.redirect || "/"; // 获取重定向路径
            this.$router.push(redirectPath);
            // this.$router.push("/");
          } else {
            this.$message({
              message: "密码错误",
              type: "error",
            });
          }
          this.$refs.slideblock.reset();
          this.flag = false;
        })
        .catch((res) => {
          this.$refs.slideblock.reset();
          this.flag = false;
          if (res.response.status == 401) {
            this.$router.push("/");
          }
        });
    },
    onSuccessP() {
      this.passwordLogin();
    },
    onSuccessF() {},
    forgetCode() {
      this.$refs.ruleForm3.validateField("name", (valid) => {
        if (valid) {
        } else {
          this.$refs.slideblock.reset();
          this.flag = true;
        }
      });
    },
    goVerify() {
      //滑块验证 成功后发送验证码y
      this.$refs.ruleForm1.validateField("name", (valid) => {
        if (valid) {
        } else {
          this.$refs.slideblock.reset();
          this.flag = true;
        }
      });
    },
    // 返回时间参数，单位为毫秒
    onSuccess() {
      if (this.activeName == "a") {
        this.getCode();
      } else {
        this.passwordLogin();
      }
    },
    // 验证不通过时的回调函数
    onFail() {},
    // 点击刷新按钮后的回调函数
    onRefresh() {
      console.log("点击了刷新图标");
    },
    // 刷新成功之后的回调函数
    onFulfilled() {
      console.log("刷新成功");
    },
    // 检测到非人为操作滑动时触发的回调函数
    onAgain() {
      console.log("检测到非人为操作的哦");
      // 刷新
      this.$refs.slideblock.reset();
    },
    // 父组件调用刷新方法（每次进来重置组件）
    handleClick() {
      this.$nextTick(() => {
        this.timeDate = "";
        clearInterval(this.timer); //清除定时器
        this.$refs.slideblock.reset();
      });
    },
    getCode() {
      let params = this.$qs.stringify({
        terminal: this.ruleForm1.name,
      });
      this.$axios
        .post(API_1 + Public.getCode, params)
        .then((res) => {
          let status = res.data.status;
          if (status) {
            this.$message({
              message: "验证码发送成功",
              type: "success",
            });
            const TIME_COUNT = 60; //倒计时60秒
            if (!this.timer) {
              this.totalTime = TIME_COUNT;
              this.codeShow = false;
              this.timer = setInterval(() => {
                if (this.totalTime > 0 && this.totalTime <= TIME_COUNT) {
                  this.totalTime--;
                } else {
                  clearInterval(this.timer);
                  this.timer = null;
                  this.coolDown = false;
                }
              }, 1000);
              this.coolDown = true;
            }
          } else {
            let msg = eval("'" + res.data.message + "'");
            this.$message({
              message: decodeURIComponent(msg),
              type: "error",
            });
          }
          this.flag = false;
        })
        .catch((res) => {
          if (res.response.status == 401) {
            this.$router.push("/");
          }
        });
    },
    submitLogin() {
      if (this.checked) {
        let params = this.$qs.stringify({
          terminal: this.ruleForm1.name,
          code: this.ruleForm1.code,
        });
        this.$axios
          .post(API_1 + Public.login, params)
          .then((res) => {
            let status = res.data.status;
            if (status) {
              this.$cookie.set("token", res.data.data.Token, "90d");
              this.$cookie.set("uid", res.data.data.id, "90d");
              this.$message({
                message: "登录成功，欢迎来到开翻",
                type: "success",
              });
              const redirectPath = this.$route.query.redirect || "/"; // 获取重定向路径
              this.$router.push(redirectPath);
            } else {
              let msg = eval("'" + res.data.message + "'");
              this.$message({
                message: decodeURIComponent(msg),
                type: "error",
              });
            }
          })
          .catch((res) => {
            if (res.response.status == 401) {
              this.$router.push("/");
            }
          });
      } else {
        this.$message({
          message: "请阅读并同意《服务协议》和《隐私政策》后进行登录",
          type: "warning",
          offset: 100,
          customClass: "loginPop",
        });
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss">
.loginPop {
  margin-left: 22%;
}
.loginHide {
  border: 0 !important;
  box-shadow: 2px 2px 2px 1px rgba(0, 0, 255, 0.2);
  .popper__arrow {
    border-width: 0 !important;
  }
}
</style>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.login {
  background: url(../assets/login/bgn.png) no-repeat center center;
  width: 100%;
  height: 100vh;
  background-size: cover;
  position: relative;
  overflow: hidden;
  .mask {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    top: 0;
    left: 0;
    z-index: 999;
    .box {
      margin: 10% auto 0;
      background: #fff;
      width: 440px;
      height: 380px;
      padding: 10px 20px;
      border-radius: 6px;
      box-sizing: border-box;
      .title {
        height: 30px;
        margin-bottom: 10px;
        border-bottom: 1px solid #ccc;
        position: relative;
        i {
          cursor: pointer;
          font-size: 18px;
          position: absolute;
          right: 0;
          bottom: 8px;
        }
      }
      .slide-verify {
        margin: 0 auto;
      }
    }
  }
  .tabsBox {
    .flex {
      display: flex;
      justify-content: space-between;
    }
    -webkit-font-smoothing: antialiased;
    position: absolute;
    right: 14%;
    top: 50%;
    transform: translateY(-50%);
    width: 532px;
    height: 568x;
    background: #ffffff;
    border-radius: 20px 20px 20px 20px;
    box-sizing: border-box;
    padding: 66px;
    ::v-deep .el-form-item {
      margin-top: 24px;
      margin-bottom: 24px;
    }
    ::v-deep .el-checkbox {
      margin-top: 10px;
    }
    ::v-deep .el-checkbox__input {
      vertical-align: top;
      margin-top: 3px;
    }
    ::v-deep .open {
      background: url(../assets/login/open.png) no-repeat center center;
      width: 16px;
      height: 16px;
      display: inline-block;
      cursor: pointer;
      vertical-align: middle;
    }
    ::v-deep .close {
      background: url(../assets/login/close.png) no-repeat center center;
      width: 16px;
      height: 16px;
      display: inline-block;
      cursor: pointer;
      vertical-align: middle;
    }

    ::v-deep .el-tabs__nav-wrap::after {
      content: none;
    }
    ::v-deep .el-checkbox__label {
      font-size: 12px;
    }
    ::v-deep .el-tabs__header {
      margin: 0;
    }
    ::v-deep .el-tabs__item {
      font-size: 16px;
      color: #999;
      height: 35px;
      padding: 0 10px;
    }

    ::v-deep .is-active {
      color: #333;
    }
    ::v-deep .el-input__inner {
      &:hover + .el-input-group__append {
        border-color: #d5e3e8;
      }
      &:focus + .el-input-group__append {
        border-top: 1px solid #d5e3e8;
        border-right: 1px solid #d5e3e8;
        border-bottom: 1px solid #d5e3e8;
        background: #fff;
      }
      &:hover {
        border: 1px solid #d5e3e8;
        background: #fff;
      }
      &:focus {
        border: 1px solid #d5e3e8;
        background: #fff;
      }
    }
    ::v-deep .is-error {
      .el-input-group__append {
        border-color: #f56c6c;
      }
    }
    ::v-deep .phoneCodeV {
      .el-input__inner {
      }
    }
    ::v-deep .phoneCode {
      background: transparent;
      border: none;
      padding-right: 15px;
      color: #597dfc;
      position: absolute;
      right: 2px;
      height: 20px;
      line-height: 20px;
      top: -2px;
    }
  }
}

// .el-main {

//   .box {
//     margin: 0 auto;
//     width: 380px;
//     height: 50%;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     margin: auto;
//     position: absolute;
//     ::v-deep .el-checkbox {
//       margin-top: 10px;
//     }
//     ::v-deep .el-checkbox__input {
//       vertical-align: top;
//       margin-top: 3px;
//     }
//     ::v-deep .el-checkbox__label {
//       font-size: 12px;
//     }
//     ::v-deep .el-tabs__item {
//       font-size: 16px;
//     }
//     ::v-deep .el-input__inner {
//       &:hover + .el-input-group__append {
//         border-color: #d5e3e8;
//       }
//       &:focus + .el-input-group__append {
//         border-top: 1px solid #d5e3e8;
//         border-right: 1px solid #d5e3e8;
//         border-bottom: 1px solid #d5e3e8;
//         background: #fff;
//       }
//       &:hover {
//         border: 1px solid #d5e3e8;
//         background: #fff;
//       }
//       &:focus {
//         border: 1px solid #d5e3e8;
//         background: #fff;
//       }
//     }

//     ::v-deep .is-error {
//       .el-input-group__append {
//         border-color: #f56c6c;
//       }
//     }
//     ::v-deep .phoneCodeV {
//       .el-input__inner {
//       }
//     }
//     ::v-deep .phoneCode {
//       background: transparent;
//       border: none;
//       padding-right: 15px;
//       color: #597dfc;
//       position: absolute;
//       right: 2px;
//       height: 20px;
//       line-height: 20px;
//       top: -2px;
//     }
//   }
// }
</style>